import styled, { css } from 'styled-components'

const DropdownItem = styled.li`
  display: flex;
  align-items: center;
  color: #25252d;
  font-size: 15px;
  font-style: normal;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  cursor: pointer;
  user-select: none;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  transition: all 150ms ease-in;

  & > :not(:last-child) {
    margin-right: 8px;
  }

  &:hover {
    background-color: #f6f6f9;
  }

  &:active {
    color: #9b09d1;
  }

  &:focus {
    outline: none;
    background-color: #f6f6f9;
  }

  ${({ inline }) =>
    inline &&
    css`
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      padding: 0 12px;

      &:hover {
        color: #ac0ae8;
        background-color: transparent;
      }
    `};
`

const DropdownHeader = styled.li`
  display: flex;
  align-items: center;
  color: #25252d;
  font-size: 15px;
  font-style: normal;
  height: 40px;
  line-height: 40px;
  user-select: none;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  pointer-events: none;
  padding: 4.5px 16px 12.5px;
  margin-bottom: 8px;
  border-radius: 0;
  border-bottom: 1px solid #d1d1e0;

  & > :not(:last-child) {
    margin-right: 8px;
  }

  ${({ inline }) =>
    inline &&
    css`
      height: 36px;
      line-height: 36px;
      border-radius: 4px;
      padding: 0 12px;
      border: none;
    `};
`

const DropdownItemText = styled.span`
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
`

const DropdownDivider = styled.li`
  width: 100%;
  height: 1px;
  background: #d1d1e0;
  pointer-events: none;
  user-select: none;
  margin: 8px 0;
`

/**
 * Attaching internal id to default props as
 * We can't rely on any other property including displayName as @emotion/styled overrides them
 */
DropdownItem.defaultProps = { internalId: 'DropdownItem' }
DropdownHeader.defaultProps = { internalId: 'DropdownHeader' }
DropdownItemText.defaultProps = { internalId: 'DropdownItemText' }
DropdownDivider.defaultProps = { internalId: 'DropdownDivider' }

export { DropdownItem, DropdownHeader, DropdownItemText, DropdownDivider }
